import * as React from 'react';

type Props = {
  className?: string
}

export default ({ className }: Props) => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="8"
          viewBox="0 0 8 8"
          className={className}
        >
          <path d="M3.063 6.989a.407.407 0 01-.577 0L.18 4.682a.612.612 0 010-.866l.288-.29c.24-.238.627-.238.867 0l1.44 1.44 3.89-3.89c.24-.24.628-.24.867 0l.288.289c.24.24.24.627 0 .866L3.063 6.99z"></path>
        </svg>
    );
};
